var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValija(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8549 7.8125H3.26498C1.46176 7.8125 0 8.86182 0 10.1562V21.0938C0 22.3882 1.46176 23.4375 3.26498 23.4375H4.35331V24.2188C4.35331 24.6504 4.84034 25 5.44164 25H7.61829C8.21959 25 8.70662 24.6504 8.70662 24.2188V23.4375H17.4132V24.2188C17.4132 24.6504 17.9003 25 18.5016 25H20.6782C21.2795 25 21.7666 24.6504 21.7666 24.2188V23.4375H22.8549C24.6581 23.4375 26.1199 22.3882 26.1199 21.0938V10.1562C26.1199 8.86182 24.6581 7.8125 22.8549 7.8125ZM21.7666 18.3594C21.7666 18.5752 21.523 18.75 21.2224 18.75H4.89747C4.59682 18.75 4.35331 18.5752 4.35331 18.3594V17.5781C4.35331 17.3623 4.59682 17.1875 4.89747 17.1875H21.2224C21.523 17.1875 21.7666 17.3623 21.7666 17.5781V18.3594ZM21.7666 13.6719C21.7666 13.8877 21.523 14.0625 21.2224 14.0625H4.89747C4.59682 14.0625 4.35331 13.8877 4.35331 13.6719V12.8906C4.35331 12.6748 4.59682 12.5 4.89747 12.5H21.2224C21.523 12.5 21.7666 12.6748 21.7666 12.8906V13.6719ZM9.79495 2.34375H16.3249V6.25H19.5899V2.34375C19.5899 1.04932 18.1281 0 16.3249 0H9.79495C7.99173 0 6.52997 1.04932 6.52997 2.34375V6.25H9.79495V2.34375Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValija);
export default __webpack_public_path__ + "static/media/valija.8290aecaeb6c0937f80abead8e37f97d.svg";
export { ForwardRef as ReactComponent };